module.exports = __webpack_public_path__ + "img/logo_castgram.da1b24dc.png";